/*jshint maxcomplexity:false */
angular.module("formApp").service("excessMessageMultipetService",
    function () {

        function getProduct(products, pet) {
            var prod = products.filter(function (prod) {
                return prod.pet === pet.uri && prod.id === pet.chosenCover.productId;
            });
            return prod[0];
        }

        return {
            getExcessMessageMultipet: function (products, pet) {
                var excessPet = angular.copy(pet);                
                var message = "";
                var c4lText = '\'s 10th birthday';
                var esstext = '\'s 8th birthday';
                var rabText = '\'s 7th birthday';
                var c4lSelectText = '\'s 7th birthday';
                var essSelecttext = '\'s 5th birthday';

                function olderExcess() {
                    return " is older and this will already apply";
                }
                
                var prod = getProduct(products, pet);
                if (prod.selectBreed && prod.selectBreed === 'true') {
                    excessPet.selectBreed = true;
                }
                if (prod.age) {
                    // console.log('prod age', prod.age);
                    excessPet.age = parseInt(prod.age, 10);
                    // console.log('excess pet', excessPet.age);
                }

                if (excessPet.type === 'dog' || excessPet.type === 'cat') {
                    if (!excessPet.selectBreed) {
                        if (excessPet.chosenCover.productLine === 'C4L') {

                            if (excessPet.age < 9) {
                                message = c4lText;
                            }
            
                            if (excessPet.age >= 10) {
                                message = olderExcess();
                            }
                        }
        
                        if (excessPet.chosenCover.productLine === 'Essential') {
                            if (excessPet.age < 7) {
                                message = esstext;
                            }
            
                            if (excessPet.age >= 8) {
                                message = olderExcess();
                            }
                        }
                    }

                    if (excessPet.selectBreed) {
                        if (excessPet.chosenCover.productLine === 'C4L') {

                            if (excessPet.age < 6) {
                                message = c4lSelectText;
                            }
            
                            if (excessPet.age >= 7) {
                                message = olderExcess();
                            }
                        }

                        if (excessPet.chosenCover.productLine === 'Essential') {

                            if (excessPet.age < 4) {
                                message = essSelecttext;
                            }

                            if (excessPet.age >= 5) {
                                message = olderExcess();
                            }
                        }
        
                    }

                }

                if (excessPet.type === 'rabbit') {
                    if (excessPet.age < 6) {
                        message = rabText;
                    }
    
                    if (excessPet.age >= 7) {
                        message = olderExcess();
                    }
                }
                return message;
            }
        };
    });